import PropTypes from 'prop-types';

export const BulkUpdateTypeDataPropType = PropTypes.shape({
  bulkApplyMessage: PropTypes.func,
  requestFilter: PropTypes.func,
  startUpdateNotificationContent: PropTypes.func,
  updateSuccessNotificationContent: PropTypes.func,
  updateSuccessActions: PropTypes.func,
});

/**
 * @typedef {object} BulkUpdateTypeDataPropType
 * @property {Function} bulkApplyMessage
 * @property {Function} requestFilter
 * @property {Function} startUpdateNotificationContent
 * @property {Function} updateSuccessNotificationContent
 * @property {Function} updateSuccessActions
 */
